import { createElement } from "react";
import Chip from "@mui/material/Chip";

/**
 * Çoklu seçimli Autocomplete etiketleri için varsayılan çizim (tema defaultProps'u).
 *
 * MUI 5.14'ün kendi varsayılanı getTagProps() sonucunu (içinde `key` var) <Chip {...props} /> ile
 * yayıyor; React 18.3 bunu konsolda uyarı olarak işaretliyor. Bu sürüm görünüm ve davranış olarak
 * MUI varsayılanıyla aynıdır, yalnızca `key` doğrudan verilir.
 */
const renderTags = (value, getTagProps, ownerState = {}) =>
    value.map((option, index) => {
        const { key, ...tagProps } = getTagProps({ index });
        const label = ownerState.getOptionLabel
            ? ownerState.getOptionLabel(option)
            : option?.label ?? option;
        return createElement(Chip, {
            key,
            label,
            size: ownerState.size,
            ...tagProps,
            ...ownerState.ChipProps,
        });
    });

/**
 * Seçenek listesi için varsayılan çizim (özel renderOption verilmemiş tüm Autocomplete'ler).
 * MUI 5.14 varsayılanı <li {...props}> ile key'i yayıyordu; görünüm aynı, key doğrudan verilir.
 */
export const renderOption = (props, option, state, ownerState = {}) => {
    const { key, ...rest } = props;
    const label = ownerState.getOptionLabel ? ownerState.getOptionLabel(option) : option?.label ?? option;
    return createElement("li", { key, ...rest }, label);
};

export default renderTags;
